import { render, staticRenderFns } from "./settings-colors.vue?vue&type=template&id=176084de&"
import script from "./settings-colors.vue?vue&type=script&lang=js&"
export * from "./settings-colors.vue?vue&type=script&lang=js&"
import style0 from "./settings-colors.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports